import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../assets/css/slot-custom.css";
import DashboardLayout from "../layout/index";
import StepHeader from "./StepHeader";
import axios from "axios";
import { APP_ROUTES } from "../../constants/approutes";
import { toast } from "react-toastify";
import FullScreenLoader from "../FullScreenLoader";
import bookappointmenticon from "../../assets/bookappointmenticon.svg";
import nodabookmedicineiconta from "../../assets/bookmedicineicon.svg";
import booklabicon from "../../assets/booklabicon.svg";
import surgery from "../../assets/surgery.svg";

export default function SlotBooking() {
  const navigate = useNavigate();
  const location = useLocation();
  const { patientCode, patient, followUpDate, doctorCode, isFollowUp ,refAppointmentId} =
    location.state || {};
    console.log(followUpDate,isFollowUp,refAppointmentId,"dfgvbhjnkm")
  // Parse a date string safely in local time. If the value is in YYYY-MM-DD,
  // create a local midnight date to avoid UTC shifting; otherwise fall back to
  // the Date constructor which handles full timestamps.
  const parseLocalDate = (value) => {
    if (!value) return null;
    if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
      const [y, m, d] = value.split("-").map(Number);
      return new Date(y, m - 1, d);
    }
    return new Date(value);
  };
  // Format a Date object to YYYY-MM-DD in LOCAL time (no UTC shift)
  const formatLocalYMD = (date) => {
    if (!date) return "";
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  };
  const [selectedDate, setSelectedDate] = useState(() => {
    // If this is a follow-up appointment, use the follow-up date
    if (isFollowUp && followUpDate) {
      return parseLocalDate(followUpDate);
    }
    return new Date();
  });
  const [selectedSlot, setSelectedSlot] = useState("");
  const [symptoms, setSymptoms] = useState("");
  const [specialization, setSpecialization] = useState("");
  const [doctorName, setDoctorName] = useState(doctorCode || "");
  const [availableSlots, setAvailableSlots] = useState([]);
  const [doctorlist, setDoctorlist] = useState([]);
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [doctorFullName, setDoctorFullName] = useState("");
  const [consultationType, setConsultationType] = useState("");
  const [consultationFee, setConsultationFee] = useState("0");
  const [originalConsultationFee, setOriginalConsultationFee] = useState(0);
  const [appointmentRequestMode, setAppointmentRequestMode] = useState("");
  const [referredBy, setReferredBy] = useState("");
  const [bookappointmentdiv, setBookappointmentdiv] = useState(false);

  console.log(patient, "patient");
  console.log("Follow-up data:", selectedDate);

  const API_URL = process.env.REACT_APP_API_URL;
  useEffect(() => {
    if (!doctorName || !consultationType) return;

    const doc = doctorlist.find((d) => d.doctorCode === doctorName);
    const feeObj = doc?.doctorFee.find(
      (f) => f.consultationtype === consultationType
    );
    const originalFee = feeObj?.consultationFee ?? 0;
    setOriginalConsultationFee(originalFee);
    setConsultationFee(originalFee.toString());
  }, [doctorName, consultationType, doctorlist]);

  useEffect(() => {
    if (selectedDate && doctorName) {
      fetchAvailableSlots(selectedDate);
    }
  }, [selectedDate, doctorName]);

  useEffect(() => {
    fetchDoctorList();
  }, []);

  // Set specialization when doctor is auto-selected from follow-up
  useEffect(() => {
    if (doctorCode && doctorlist.length > 0) {
      const selectedDoctor = doctorlist.find(
        (doc) => doc.doctorCode === doctorCode
      );
      if (selectedDoctor) {
        setSpecialization(selectedDoctor.specialization || "");
        setDoctorFullName(selectedDoctor.fullName || "");
      }
    }
  }, [doctorCode, doctorlist]);

  const fetchDoctorList = async () => {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const clinicId = localStorage.getItem("clinicId");
    try {
      const response = await axios.get(
        `${API_URL}doctor/list?clinicId=${tenantId}`,
        {
          headers: { Authorization: `Bearer ${token}`, tenantId: tenantId },
        }
      );
      setDoctorlist(response.data);
    } catch (error) {
      console.error("Error fetching doctor list:", error);
    }
  };

  const fetchAvailableSlots = async (date) => {
    const formattedDate = formatLocalYMD(date);
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const clinicId = localStorage.getItem("clinicId");

    try {
      const selectedDoctor = doctorlist.find((d) => d.doctorCode === doctorName);
      const params = {
        doctorCode: doctorName,
        date: formattedDate,
        clinicId: clinicId,
      };
      if (selectedDoctor && selectedDoctor.slotDuration != null) {
        params.slotDuration = selectedDoctor.slotDuration;
      }

      const response = await axios.get(`${API_URL}slot/available`, {
        params,
        headers: { Authorization: `Bearer ${token}`, tenantId: tenantId },
      });
      setAvailableSlots(response.data || []);
    } catch (error) {
      console.error("Error fetching slots:", error);
      setAvailableSlots([]);
    }
  };

  const handleNext = async () => {
    if (!doctorName) {
      toast.error("Please select a doctor.");
      return;
    }
    if (!consultationType) {
      toast.error("Please select a consultation type.");
      return;
    }

    if (!selectedSlot) {
      toast.error("Please select a time slot.");
      return;
    }

    if (appointmentRequestMode === "Refered" && !referredBy.trim()) {
      toast.error("Please enter who referred you.");
      return;
    }

    setIsLoggingIn(true);
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const userId = localStorage.getItem("userId");
    const clinicId = localStorage.getItem("clinicId");
    const email = localStorage.getItem("email") || (() => {
      const userStr = localStorage.getItem("user");
      if (userStr) {
        try {
          const user = JSON.parse(userStr);
          return user.email;
        } catch (e) {
          console.error("Error parsing user from localStorage:", e);
        }
      }
      return null;
    })() || "unknown@example.com";
    
    // Debug logging
    console.log("Email from localStorage:", localStorage.getItem("email"));
    console.log("User from localStorage:", localStorage.getItem("user"));
    console.log("Final email being used:", email);
    
    const payload = {
      patientId: patientCode,
      userId: doctorName,
      clinicId: clinicId,
      locationId: "",
      whenAppointment: formatLocalYMD(selectedDate),
      fromTime: selectedSlot.split("-")[0],
      toTime: selectedSlot.split("-")[1],
      consultationsReason: symptoms,
      status: "QUEUED",
      createdBy: userId,
      modifiedBy: userId,
      txnId: "",
      totalAmount: originalConsultationFee,
      modifiedFeeAmount: parseFloat(consultationFee) || 0,
      feeModifiedBy: email,
      // payMode: "CASH",
      consultationType: consultationType,
      appointmentRequestMode: appointmentRequestMode,
      referredBy: appointmentRequestMode === "Refered" ? referredBy : null,
      membershipCode: null,
      voucherCode: null,
      voucherTransId: null,
      cancelledReason: null,
      remarks: null,
      refundId: null,
      doctorStartTime: null,
      doctorEndTime: null,
      patientStartTime: null,
      patientEndTime: null,
    };
    if (isFollowUp) {
      payload.isFollowup = "Y";
      if (refAppointmentId) {
        payload.refAppointmentId = refAppointmentId;
      }
    }
    console.log(payload, "sedrftyguhu");
    try {
      const res = await axios.post(
        `${API_URL}queue/appointment-booking`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}`, tenantId: tenantId },
        }
      );
      console.log(res.data, "fyguhjikl");
      localStorage.setItem("slotdata", JSON.stringify(res.data));
      localStorage.setItem("patientcode", patientCode); // Add patient code to localStorage
      localStorage.setItem("doctorFullName", doctorFullName);
      localStorage.setItem("specialization", specialization);
      localStorage.setItem("consultationType", consultationType);
      localStorage.setItem("consultationFee", consultationFee);
      localStorage.setItem("appointmentRequestMode", appointmentRequestMode);
      setIsLoggingIn(false);

      if (res.status === 200) {
        toast.success("Slot selected successfully");
        navigate(APP_ROUTES.PATIENTPREVIEW, {
          state: {
            appointmentId: res.data.id,
            patientId: patientCode,
          },
        });
      } else {
        toast.error("Booking failed");
      }
    } catch (err) {
      console.error("Booking failed", err);
      toast.error("Something went wrong while booking");
      setIsLoggingIn(false);
    }
  };
  console.log(doctorlist, "doctorlist");
  return (
    <>
      {isLoggingIn && <FullScreenLoader message="" />}
      <DashboardLayout>
        <div className="min-h-screen  md:pt-10 bg-white  md:px-6">
          <StepHeader />
          {patient && (
            <div className="bg-teal-50 border-l-4 border-[#004172] px-4 py-3 mb-8 rounded-r-lg shadow-sm">
              <div className="flex items-center gap-4 text-sm">
                <span className="font-bold text-teal-800">
                  👤 {patient.firstName} {patient.lastName}
                </span>
                <span className="font-semibold text-teal-800">
                  📱 {patient.mobileNumber}
                </span>
                {isFollowUp && (
                  <span className="font-semibold text-orange-600 bg-orange-100 px-2 py-1 rounded-md">
                    🔄 Follow-up Appointment
                  </span>
                )}
              </div>
            </div>
          )}

          <>
            {/* Form Fields - Responsive Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-6 md:mb-8 max-w-full lg:max-w-6xl">
              <div className="sm:col-span-2 lg:col-span-1">
                <label className="block mb-1 font-medium text-sm text-[#004172]">
                  Symptoms
                </label>
                <input
                  type="text"
                  value={symptoms}
                  onChange={(e) => setSymptoms(e.target.value)}
                  placeholder="Enter symptoms"
                  className="w-full h-[50px] px-4 py-2 border border-gray-300 rounded-md text-sm"
                />
              </div>

              <div>
                <label className="block mb-1 font-medium text-sm text-[#004172]">
                  Doctor Name
                </label>
                <select
                  value={doctorName}
                  onChange={(e) => {
                    const selectedCode = e.target.value;
                    setDoctorName(selectedCode);
                    const selectedDoctor = doctorlist.find(
                      (doc) => doc.doctorCode === selectedCode
                    );
                    setSpecialization(selectedDoctor?.specialization || "");
                    setDoctorFullName(selectedDoctor?.fullName || "");
                  }}
                  className="w-full h-[50px] px-4 py-2 border border-gray-300 rounded-md bg-white text-sm"
                >
                  <option value="">Select</option>
                  {doctorlist?.filter(doctor => doctor.userActive === "active").map((doctor) => (
                    <option key={doctor.doctorCode} value={doctor.doctorCode}>
                      Dr. {doctor.fullName}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block mb-1 font-medium text-sm text-[#004172]">
                  Specialization
                </label>
                <input
                  type="text"
                  value={specialization}
                  readOnly
                  className="w-full h-[50px] px-4 py-2 border border-gray-300 rounded-md bg-gray-100 text-sm"
                />
              </div>

              <div>
                <label className="block mb-1 font-medium text-sm text-[#004172]">
                  Consultation Type
                </label>
                <select
                  value={consultationType}
                  onChange={(e) => setConsultationType(e.target.value)}
                  className="w-full h-[50px] px-4 py-2 border border-gray-300 rounded-md bg-white text-sm"
                >
                  <option value="" disabled hidden>
                    Select Type
                  </option>
                  <option value="V">Video</option>
                  <option value="I">In Person</option>
                </select>
              </div>

              <div>
                <label className="block mb-1 font-medium text-sm text-[#004172]">
                  Consultation Fee (₹)
                </label>
                <input
                  type="number"
                  value={consultationFee}
                  onChange={(e) => setConsultationFee(e.target.value)}
                  placeholder="Enter consultation fee"
                  className="w-full h-[50px] px-4 py-2 border border-gray-300 rounded-md bg-white text-sm no-spinner"
                  min="0"
                  step="0.01"
                />
              </div>

              <div>
                <label className="block mb-1 font-medium text-sm text-[#004172]">
                Discovery Source
                </label>
                <select
                  value={appointmentRequestMode}
                  onChange={(e) => setAppointmentRequestMode(e.target.value)}
                  className="w-full h-[50px] px-4 py-2 border border-gray-300 rounded-md bg-white text-sm"
                >
                  <option value="" disabled hidden>
                    Select Type
                  </option>
                  <option value="Walkin">Walkin</option>
                  <option value="In Call">In Call</option>
                  <option value="Refered">Refered</option>
                  <option value="Social Media">Social Media</option>
                  <option value="Google Search">Google Search</option>
                  <option value="Camp/Event">Camp/Event</option>
                  <option value="Other">Other</option>

                </select>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-6 md:mb-8 max-w-full lg:max-w-6xl">

              {/* Show referred by input field when "Refered" is selected */}
              {appointmentRequestMode === "Refered" && (
                <div>
                  <label className="block mb-1 font-medium text-sm text-[#004172]">
                    Referred By
                  </label>
                  <input
                    type="text"
                    value={referredBy}
                    onChange={(e) => setReferredBy(e.target.value)}
                    placeholder="Enter who referred you"
                    className="w-full h-[50px] px-4 py-2 border border-gray-300 rounded-md text-sm"
                  />
                </div>
              )}
            </div>

            {/* Calendar and Slots Section */}
            <div className="flex flex-col lg:flex-row gap-6 lg:gap-12 items-start">
              {/* Calendar Section */}
              <div className="w-full lg:w-auto">
                <div className="bg-[#f5faff] p-4 rounded-md shadow-sm max-w-full overflow-hidden">
                  <div className="calendar-wrapper">
                    {isFollowUp && followUpDate && (
                      <div className="mb-3 text-sm text-gray-600 bg-green-50 p-2 rounded border border-green-200">
                        📅 Follow-up appointment scheduled for: <span className="font-semibold text-green-700">
                          {parseLocalDate(followUpDate)?.toLocaleDateString()}
                        </span>
                      </div>
                    )}
                    <DatePicker
                      selected={selectedDate}
                      onChange={(date) => {
                        console.log('Date selected:', date, 'isFollowUp:', isFollowUp, 'followUpDate:', followUpDate);
                        setSelectedDate(date);
                      }}
                      inline
                      minDate={isFollowUp && followUpDate ? parseLocalDate(followUpDate) : new Date()}
                      filterDate={(date) => {
                        // Check if selected doctor is inactive
                        if (doctorName) {
                          const selectedDoctor = doctorlist.find(
                            (doc) => doc.doctorCode === doctorName
                          );
                          if (selectedDoctor?.userActive === "inactive") {
                            return false; // Hide all dates for inactive doctors
                          }
                        }
                        
                        // For follow-up appointments, only allow dates from follow-up date onwards
                        if (isFollowUp && followUpDate) {
                          const followUpDateObj = parseLocalDate(followUpDate);
                          followUpDateObj.setHours(0, 0, 0, 0);
                          const currentDate = new Date(date);
                          currentDate.setHours(0, 0, 0, 0);
                          const isAllowed = currentDate >= followUpDateObj;
                          console.log('Date filtering:', {
                            currentDate: currentDate.toISOString().split('T')[0],
                            followUpDate: followUpDateObj.toISOString().split('T')[0],
                            isAllowed: isAllowed,
                            dateString: date.toDateString()
                          });
                          return isAllowed;
                        }
                        // For regular appointments, allow today and future dates
                        const today = new Date();
                        today.setHours(0, 0, 0, 0);
                        const currentDate = new Date(date);
                        currentDate.setHours(0, 0, 0, 0);
                        return currentDate >= today;
                      }}
                      calendarClassName="custom-calendar responsive-calendar"
                      dayClassName={(date) => {
                        // Add special styling for the follow-up date itself
                        if (isFollowUp && followUpDate && date.toDateString() === parseLocalDate(followUpDate).toDateString()) {
                          console.log('Follow-up date styling applied to:', date.toDateString());
                          return 'react-datepicker__day--followup-date';
                        }
                        return '';
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* Slot Grid Section */}
              <div className="flex-1 w-full">
                <h3 className="text-base md:text-lg font-semibold text-[#004172] mb-4">
                  Available Slots
                </h3>
                {availableSlots.length === 0 ? (
                  <div className="bg-gray-50 p-6 rounded-md text-center">
                    <p className="text-sm text-gray-500">
                      No slots available for the selected date.
                    </p>
                  </div>
                ) : (
                  <div className="h-80 overflow-y-auto border border-gray-200 rounded-md p-4 bg-gray-50">
                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4">
                    {/* {availableSlots
                    .filter((s) => s.available === "Y")
                    .map((s) => (
                      <button
                        key={s.slot}
                        onClick={() => setSelectedSlot(s.slot)}
                        className={`w-full border border-[#004172] px-3 py-2.5 text-xs sm:text-sm rounded font-medium transition-all duration-200 min-h-[44px] ${
                          selectedSlot === s.slot
                            ? "bg-[#004172] text-white transform scale-95"
                            : "text-[#004172] hover:bg-[#e9f2f7] active:scale-95"
                        }`}
                      >
                        {s.slot.split("-")[0]}
                      </button>
                    ))} */}

                    {availableSlots.map((s, index) => (
                      <button
                        key={index}
                        onClick={() => setSelectedSlot(s.slot)}
                        disabled={s.available === "N"} // disable if not available
                        className={`px-4 py-2 rounded-md m-1 text-sm border transition-all duration-200 
      ${
        s.available === "Y"
          ? selectedSlot === s.slot
            ? "bg-[#004172] text-white transform scale-95 border-[#004276]"
            : "text-[#004172] border-[#004276] hover:bg-[#e9f2f7] active:scale-95"
          : "border-gray-300 text-gray-400 bg-gray-100 cursor-not-allowed"
      }`}
                      >
                        {s.slot.split("-")[0]}
                      </button>
                    ))}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Book Button */}
            <div className="flex justify-center mt-8 md:mt-10 pb-6">
              <button
                onClick={handleNext}
                disabled={isLoggingIn}
                className="bg-gradient-to-r from-[#004172] to-[#3cba84] text-white rounded-full px-8 md:px-10 py-3 font-medium w-full sm:w-auto sm:min-w-[335px] max-w-md disabled:opacity-70 disabled:cursor-not-allowed transition-all duration-200 hover:shadow-lg active:scale-95"
              >
                {isLoggingIn ? "Loading..." : "Book"}
              </button>
            </div>
          </>
        </div>

        {/* Custom CSS for responsive calendar */}
        <style jsx>{`
          .calendar-wrapper {
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
          }



          /* Style for the follow-up date itself */
          .custom-calendar .react-datepicker__day--followup-date {
            background-color: #10b981 !important;
            color: white !important;
            font-weight: bold !important;
          }

          .custom-calendar .react-datepicker__day--followup-date:hover {
            background-color: #059669 !important;
            color: white !important;
          }

          /* Make disabled (past) dates clearly grey */
          .custom-calendar .react-datepicker__day--disabled:not(.react-datepicker__day--selected) {
            color: #9CA3AF !important; /* gray-400 */
            background-color: #F3F4F6 !important; /* gray-100 */
            cursor: not-allowed !important;
          }

          

          @media (max-width: 640px) {
            .responsive-calendar {
              font-size: 14px;
            }

            .responsive-calendar .react-datepicker__day {
              width: 2rem;
              height: 2rem;
              line-height: 2rem;
            }

            .responsive-calendar .react-datepicker__day-name {
              width: 2rem;
              font-size: 12px;
            }

            .responsive-calendar .react-datepicker__header {
              padding: 8px 0;
            }

            .responsive-calendar .react-datepicker__current-month {
              font-size: 16px;
              margin-bottom: 8px;
            }

            .responsive-calendar .react-datepicker__navigation {
              top: 12px;
            }
          }

          @media (max-width: 480px) {
            .responsive-calendar .react-datepicker__day {
              width: 1.8rem;
              height: 1.8rem;
              line-height: 1.8rem;
              font-size: 12px;
            }

            .responsive-calendar .react-datepicker__day-name {
              width: 1.8rem;
              font-size: 11px;
            }


          }
        `}</style>
      </DashboardLayout>
    </>
  );
}
